<template>
  <v-card max-width="500px">
    <v-card-title class="subtitle-2">
      <v-icon>mdi-run</v-icon>
      <span class="ml-2">{{ $t("live.activity.geolocation.title") }}</span>
    </v-card-title>
    <v-card-text class="pb-0">
      <p>
        {{ $t("live.activity.geolocation.message") }}
      </p>
    </v-card-text>
    <v-card-actions class="mt-0 pa-3">
      <v-spacer />
      <v-btn class="mr-1" text @click="continueClick()">
        {{ $t("live.activity.geolocation.skip") }}
      </v-btn>
      <v-btn color="primary" :loading="waitForPermission" @click="allow()">{{
        $t("live.activity.geolocation.allow")
      }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      waitForPermission: false,
    };
  },
  methods: {
    async allow() {
      this.waitForPermission = true;
      try {
        await this.$store.dispatch("ENABLE_GEOLOCATION");
        this.continueClick();
      } catch (err) {
        console.log(err);
      } finally {
        this.waitForPermission = false;
      }
    },
    continueClick() {
      this.$emit("continue");
    },
  },
};
</script>

<style scoped></style>
